import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { utils, user } from '@ohif/core';

/** Extensions */
import { extensionManager } from './../App.js';
import {
  MarkExtension,
  AnalysisReportPanel,
} from '@ohif/viewer/src/appExtensions';
import { useIsResearch } from '../appExtensions/Mark/hook.js';
//
import ConnectedViewerRetrieveStudyData from '../connectedComponents/ConnectedViewerRetrieveStudyData';
import useServer from '../customHooks/useServer';
import useQuery from '../customHooks/useQuery';
import useAiCheck from '../customHooks/useAiCheck';
const { urlUtil: UrlUtil } = utils;

/**
 * Get array of seriesUIDs from param or from queryString
 * @param {*} seriesInstanceUIDs
 * @param {*} location
 */
const getSeriesInstanceUIDs = (seriesInstanceUIDs, routeLocation) => {
  const queryFilters = UrlUtil.queryString.getQueryFilters(routeLocation);
  const querySeriesUIDs = queryFilters && queryFilters['seriesInstanceUID'];
  const _seriesInstanceUIDs = seriesInstanceUIDs || querySeriesUIDs;

  return UrlUtil.paramString.parseParam(_seriesInstanceUIDs);
};

function ViewerRouting({ match: routeMatch, location: routeLocation }) {
  const {
    project,
    location,
    dataset,
    dicomStore,
    studyInstanceUIDs,
    seriesInstanceUIDs,
  } = routeMatch.params;

  // Set the user's default authToken for outbound DICOMWeb requests.
  // Is only applied if target server does not set `requestOptions` property.
  //
  // See: `getAuthorizationHeaders.js`
  let query = useQuery();
  let aiCheckId = useAiCheck();
  const authToken = query.get('token');
  if (!aiCheckId) {
    aiCheckId = query.get('aiCheckId');
  }

  if (authToken) {
    user.getAccessToken = () => authToken;
  }

  const server = useServer({ project, location, dataset, dicomStore });
  let newstudyInstanceUIDs;
  if (studyInstanceUIDs && studyInstanceUIDs.indexOf('?') != -1) {
    newstudyInstanceUIDs = studyInstanceUIDs.split('?')[0];
  }
  const studyUIDs = server.studyInstanceUIDs
    ? [server.studyInstanceUIDs]
    : UrlUtil.paramString.parseParam(
        newstudyInstanceUIDs ? newstudyInstanceUIDs : studyInstanceUIDs
      );
  const seriesUIDs = getSeriesInstanceUIDs(seriesInstanceUIDs, routeLocation);

  const isScience = useIsResearch();
  const selectedRightSidePanel = isScience ? 'mark-list' : 'analysis-report';
  useEffect(() => {
    if (isScience) {
      extensionManager.registerExtensions([MarkExtension]);
      extensionManager.unregisterExtensions(['analysis-report']);
    } else {
      extensionManager.registerExtensions([AnalysisReportPanel]);
      extensionManager.unregisterExtensions(['mark']);
    }
  }, [isScience]);

  if (server && studyUIDs) {
    return (
      <ConnectedViewerRetrieveStudyData
        studyInstanceUIDs={studyUIDs}
        seriesInstanceUIDs={seriesUIDs}
        aiCheckId={aiCheckId}
        selectedRightSidePanel={selectedRightSidePanel}
      />
    );
  }

  return null;
}

ViewerRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      studyInstanceUIDs: PropTypes.string.isRequired,
      seriesInstanceUIDs: PropTypes.string,
      dataset: PropTypes.string,
      dicomStore: PropTypes.string,
      location: PropTypes.string,
      project: PropTypes.string,
      aiCheckId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }),
  location: PropTypes.any,
};

export default ViewerRouting;
